import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './error-page.module.css';

function TravelErrorPanel() {
  return (
    <Stack className={classes.root} align="center">
      <div className={classes.label}>oops</div>
      <Title pb="xl" className={classes.title}>
        Well... that was unexpected
      </Title>
      <Text c="dimmed" size="lg" ta="center" className={classes.description}>
        We hit a little turbulence. Your misguided tour is logged, and our crew is already getting things back on
        course.
      </Text>
      <Text c="dimmed" size="md" ta="center" className={classes.description}>
        Refresh to reboard, or head home and start your journey again.
      </Text>
      <Group justify="center" pt="xl">
        <Button size="md" component={Link} to="/">
          Back to home
        </Button>
        <Button variant="subtle" size="md" onClick={() => window.location.reload()}>
          Refresh page
        </Button>
      </Group>
    </Stack>
  );
}

export default TravelErrorPanel;
